module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "rm-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedRequirements), function(requirement) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(requirement.prefix) + _vm._s(requirement.display_id ? requirement.display_id : requirement.requirement_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(requirement.name))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(requirement.description))])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f96344d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/confluence/ConfluenceLinkedRequirementsMacroView.vue
// module id = 1006
// module chunks = 1